import { useMutation } from '@hooks/reactQuery';

import { disableMiddlewareSMO } from '@api/middlewareSMO';

import { MIDDLEWARE_SMO_DISABLE } from '@constants/queryKeys';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareSMODisableReturned {
	disableMiddlewareSMO: (id: string) => void;
	isLoadingDisableMiddlewareSMO: boolean;
}

const useMutateMiddlewareSMODisable = (handleCloseModal: () => void): IUseMutateMiddlewareSMODisableReturned => {
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_SMO_DISABLE],
		mutationFn: disableMiddlewareSMO,
		onSuccess: () => {
			handleCloseModal();

			return invalidateMiddlewareSMO();
		},
	});

	return {
		disableMiddlewareSMO: mutate,
		isLoadingDisableMiddlewareSMO: isLoading,
	};
};

export default useMutateMiddlewareSMODisable;
